import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';
import lineasFondo from '../img/mision/productCurvyLines.png';
import imagen from '../img/quienessomos.webp';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.light,
    overflow: 'hidden',
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 10),
    margin: 'auto',
    '& div': {
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0,20),
      },
    }
  },
  title: {
    marginBottom: theme.spacing(14),
  },
  number: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  image: {
    height: 'auto',
    marginBottom: theme.spacing(4),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
    opacity: 0.7,
  },
  button: {
    marginTop: theme.spacing(8),
  },
});

function ProductHowItWorks(props) {
  const { classes } = props;
  

  return (
    <section id='quienes' className={classes.root}>
      <Container className={classes.container}>
        <img
          src= {lineasFondo}
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Typography variant="h4" marked="center" className={classes.title} component="h2">
          Quienes Somos
        </Typography>
        <div>
          <Grid container>
            <Grid item md={6} xs={12}>
              <div className={classes.item}>
                <img
                  src={imagen}
                  alt="quienessomos"
                  className={classes.image}
                />
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div className={classes.item}>
                <div>
                  <Typography variant="h5" align="center">
                    Desde hace mas de cuarenta años trabajamos codo a codo con pequeñas, medianas y grandes empresas 
                    brindando asesoramiento en todos los aspectos de su ciclo comercial.
                  </Typography>
                </div>
                <div>
                  <Typography variant="h5" align="center">
                    Nos apoyamos en nuestra experiencia, el uso de mejores practicas, la nuevas 
                    tecnologias, la capacitacion permanente y la innovacion constante.
                  </Typography>
                </div>
                <div>
                  <Typography variant="h5" align="center">
                      Priorizamos el trabajo en equipo y la comunicación.
                  </Typography>
                </div>
                <div>
                  <Typography variant="h5" align="center">
                    Creemos en las relaciones a largo plazo, la integridad y el profesionalismo.
                  </Typography>
                </div>
              </div>
            </Grid>       
         </Grid>
        </div>      
      </Container>
    </section>
  );
}

ProductHowItWorks.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHowItWorks);
